export const markerIcon = {
  strokeColor: '#FF00FF',
  strokeOpacity: 1,
  fillColor: '#FF00FF',
  fillOpacity: 1,
  scale: 4
}
